import axios from "axios";
import WriteToLog from "./WriteToLog";

/**
 * Get lab values from EHR for the given LOINC codes
 * @param {*} patFHIRID 
 * @param {*} encodedFloID 
 * @param {*} fhir_server 
 * @param {*} access_token 
 * @returns 
 */
async function getObservationFlowsheet(patFHIRID, encodedFloID, codeText, fhir_server, access_token) {
  if (encodedFloID) {
    const lab = {};
    const allLabs = {};
    let errorCode = "";
  
    var date = new Date();
    date.setHours(date.getHours() - 4);
    const isoStringWithoutMs = date.toISOString().slice(0, 19) + 'Z';
  
    var date2 = new Date();
    date2.setHours(date2.getHours() - 1);
    const isoStringWithoutMs2 = date2.toISOString().slice(0, 19) + 'Z';
  
    const ehrconfig = await axios.get('ehrconfig.json');
    let observationSearchUrl = ehrconfig.data["EHR_OBSERVATION_SEARCH_R4"];
    let getObservationFlowsheetUrl = fhir_server + observationSearchUrl + '?code=' + encodedFloID + '&patient=' + patFHIRID + '&date=ge' + isoStringWithoutMs + '&date=le' + isoStringWithoutMs2;
  
    try {
      let response = await axios.get(
        getObservationFlowsheetUrl,
        {
          headers:
          {
            'Authorization': 'Bearer ' + access_token,
            'Accept': 'application/json'
          }
        });
      WriteToLog("getObservationFlowsheet Observation.Search (R4) FHIR response: " + JSON.stringify(response.data));
      if (response.data.total > 0) {
        let entryArray = response.data.entry;
  
        for (var i= 0; i < entryArray.length; i++) {
          if (entryArray[i].resource !== undefined) {
            let resourceType = entryArray[i].resource.resourceType;
            if (resourceType === "Observation" && entryArray[i].resource.code !== undefined) {
              if (entryArray[i].resource.valueQuantity !== undefined) {
                // New
                let labCode = "";
                let labDisplay = "";
                let codingArray = entryArray[i].resource.code.coding;
                if (codingArray.length > 0) {
                  for(var c=0; c<codingArray.length; c++) {
                    var system = codingArray[c].system;
                    if (system.includes("loinc")) {
                      labCode = codingArray[c].code;
                      //console.log("labcode: " + labCode);
                      labDisplay = codingArray[c].display;
                    }
                  }
                }
                // End of New
  
                // Get the latest value from the top
                if(labCode !== "" && lab[labCode] === undefined ) {
                  lab[labCode] = {};
                  lab[labCode].description = labDisplay;
                  lab[labCode].value = entryArray[i].resource.valueQuantity.value;
                  lab[labCode].unit = entryArray[i].resource.valueQuantity.unit;
                  lab[labCode].timestamp = entryArray[i].resource.issued;
                }
              }
  
            }
          }
        }
  
        allLabs[codeText] = lab;
        WriteToLog("getObservationFlowsheet Observation.Search (R4) response for " + codeText + ": " + JSON.stringify(lab));      
        return allLabs;
      } else {
        //ehr value empty if total is 0
        let entryArray = response.data.entry;
        for (var j = 0; j < entryArray.length; j++) {
          if (entryArray[j].resource !== undefined) {
            let resourceType = entryArray[j].resource.resourceType;
            if (resourceType === "OperationOutcome" && entryArray[j].resource.issue !== undefined) {
              let issueArray = entryArray[j].resource.issue;
              if (issueArray.length > 0) {
                if (entryArray[j].resource.issue[0].diagnostics !== undefined)
                {
                  errorCode = "Error: " + entryArray[j].resource.issue[0].diagnostics;
                } else {
                  errorCode = entryArray[j].resource.issue[0].details.text;
                }
              }
            }
          }
        }
        return errorCode;
      }
    } catch (error) {
      if (!error.message.includes("401")) { // 401 - Access Token Expired
        WriteToLog("getObservationFlowsheet Observation.Search FHIR error: " + error.message);
      }
      return null; 
    }
  }
}

export default getObservationFlowsheet;
